var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 4C13.3996 4.44183 13.0414 4.8 12.5996 4.8L1.39961 4.8C0.957781 4.8 0.599609 4.44183 0.599609 4C0.599609 3.55817 0.957781 3.2 1.39961 3.2L12.5996 3.2C13.0414 3.2 13.3996 3.55817 13.3996 4Z",
    fill: "#2B343E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 12C13.3996 12.4418 13.0414 12.8 12.5996 12.8L1.39961 12.8C0.957781 12.8 0.599609 12.4418 0.599609 12C0.599609 11.5582 0.957781 11.2 1.39961 11.2H12.5996C13.0414 11.2 13.3996 11.5582 13.3996 12Z",
    fill: "#2B343E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1653 3.43431C13.4777 3.74673 13.4777 4.25327 13.1653 4.56569L9.96529 7.76569C9.65288 8.0781 9.14634 8.0781 8.83392 7.76569C8.5215 7.45327 8.5215 6.94673 8.83392 6.63432L11.4682 4L8.83392 1.36569C8.5215 1.05327 8.5215 0.546734 8.83392 0.234315C9.14634 -0.0781049 9.65288 -0.0781049 9.96529 0.234315L13.1653 3.43431Z",
    fill: "#2B343E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833925 12.5657C0.521505 12.2533 0.521505 11.7467 0.833925 11.4343L4.03393 8.23432C4.34634 7.9219 4.85288 7.9219 5.1653 8.23432C5.47772 8.54673 5.47772 9.05327 5.1653 9.36569L2.53098 12L5.1653 14.6343C5.47771 14.9467 5.47771 15.4533 5.1653 15.7657C4.85288 16.0781 4.34634 16.0781 4.03392 15.7657L0.833925 12.5657Z",
    fill: "#2B343E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/doubleArrows.a5ada1b5a1dab56c6ec13bfeae318107.svg";
export { ForwardRef as ReactComponent };